import React from 'react';
import { withRouter } from 'hooks/useRouter';
import PropTypes from 'prop-types';
import compose from 'lodash.compose';
import I18n from 'hooks/useI18n';

import withCommonStateAction from 'components/HOC/withCommonStateAction';

import { FEED_HOME, ROOT_FOLDER, ERROR_PAGE } from 'redhotpie-shared-lib/constants/routes';
import * as CONSTANTS from 'redhotpie-shared-lib/constants/constants';
import { phoneDetect } from 'redhotpie-shared-lib/functions/utils';
import MemberButton from 'components/common/buttons/MemberButton';

import './styles.scss';
import withLoginUser from 'components/HOC/withLoginUser';
import { getKey } from 'redhotpie-shared-lib/functions/storageHelper';
import { SESSIONS } from 'redhotpie-shared-lib/constants/constants';
import { LOGIN } from 'redhotpie-shared-lib/constants/routes';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };

    this.isMobile = phoneDetect();
    this.navigateToFeedHome = this.navigateToFeedHome.bind(this);
    this.handleLogErrorToServer = this.handleLogErrorToServer.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error('Error: ', error);
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const logData = {
      type: CONSTANTS.LOG_TYPE.ERROR,
      message: error && error.message ? encodeURI(JSON.stringify(error.message).replace(/'/g, '"')) : 'undefined',
      category: process.env.REACT_APP_IS_PRODUCTION === 'false' ? CONSTANTS.LOG_CATEGORY.GLOBAL_TEST : CONSTANTS.LOG_CATEGORY.GLOBAL,
      stackTrace: `Error happened on ${this.props.pageName}: ${encodeURI(JSON.stringify(error.info ? error.info : info).replace(/'/g, '"'))}`,
    };
    const e = {
      message: `${this.props.pageName}--${logData.message}`,
      info,
      name: this.props.pageName,
    };
    if (process.env.NODE_ENV !== 'development') {
      this.handleLogErrorToServer(logData);
    }
  }

  componentDidUpdate(prevProps, preState) {
    if (preState.hasError !== this.state.hasError && this.state.hasError) {
      this.navigateToFeedHome();
    }
  }

  handleLogErrorToServer(logData) {
    if (this.timeoutLog) {
      return;
    }
    this.timeoutLog = setTimeout(() => {
      clearTimeout(this.timeoutLog);
      this.timeoutLog = null;
      this.props.commonStateActions.logError(logData).then(() => {
        this.navigateToFeedHome();
      });
    }, 50);
  }

  navigateToFeedHome() {
    const pathFeedHome = `${ROOT_FOLDER}/${FEED_HOME}`;
    const pathErrorPage = `${ROOT_FOLDER}/${ERROR_PAGE}`;
    const isLogin = this.props.loginReducer.isLogin && getKey(SESSIONS.RHP_TOKEN);
    this.setState({ hasError: !isLogin });
    this.props.commonStateActions.updateCommonStateReducerSuccess({ isAppError: true });

    if (isLogin) {
      switch (this.props.location.pathname) {
        case pathFeedHome:
          // Redirect to error page when Error on feed-home
          this.props.history.push(pathErrorPage);
          break;
        case pathErrorPage:
          console.log('Stop switch to page');
          break;
        default:
          // switch to feed-home screen
          this.props.history.push(pathFeedHome);
          break;
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-container">
          <div className="error-body">
            <span>{I18n.t('NoConnection.OOOPs')}</span>
            <span>{I18n.t('NoConnection.LookLikeSomethingWentWrong')}</span>
          </div>
          <MemberButton text={'Login'} onClick={() => window.open(`${ROOT_FOLDER}/${LOGIN}`, '_self')} color="primary" />
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  pageName: PropTypes.string,
  children: PropTypes.object,
  history: PropTypes.object,
  commonStateActions: PropTypes.object,
  isRoot: PropTypes.bool,
  location: PropTypes.object,
};

export default compose(withRouter, withCommonStateAction, withLoginUser)(ErrorBoundary);
